export const POLICIES_BASE_URL = '/policy';
export const TEMPLATES_BASE_URL = `${POLICIES_BASE_URL}/template`;
